import styled from 'styled-components';

export const Container = styled.div`
  max-width: 630px;
  padding: 0 15px;
  margin: 0 auto;
`;

export const Main = styled.main`
  margin: 18px 0;
  @media (min-width: 768px) {
    margin: 24px 0;
  }
`;
